import React, { useEffect } from "react";

import { Row, Col, Spinner, Form, Button } from "react-bootstrap/";
import { capitalize } from "../../constants/constants";

import useAccesorios from "./hooks/useAccesorios";

import accesoriosSeccion from "../../assets/images/secciones/accesoriosSeccion.jpg";
import accesoriosSeccionMobile from "../../assets/images/secciones/accesoriosSeccionMobile.jpg";

export default function CatalogoAccesorios() {
  const {
    spinner,
    genericCardstoRender,
    buttonsToRender,
    /* marcaSeleccionada, */
    handleChangeFilter,
    search,
    getPagination,
    seleccion,
    handleSearch,
  } = useAccesorios();

  useEffect(() => {
    window.scrollTo(0, 0);
    window.dataLayer.push({ event: "accesorios" });
  }, []);

  return (
    <>
      <Row className="m-0 p-0">
        <Col xs={12} className="m-0 p-0">
          <p className="textoUsados text-left">Accesorios</p>
          <picture>
            <source media="(min-width:600px)" srcset={accesoriosSeccion} />
            <img
              src={accesoriosSeccionMobile}
              alt="accesorios"
              style={{ width: "100%" }}
            />
          </picture>
        </Col>
      </Row>
      <Row className="m-0 mt-3 mb-3 p-0 justify-content-center">
        {/*   {marcaSeleccionada === MARCAS.TOYOTA_CERTIFICADO ? ( //aca puede venir el banner de accesorios
          <Col className="text-left p-2" xs={12} md={{ span: 4 }}>
            <Image
              className="mb-4"
              style={{ width: "90%", borderRadius: "5px" }}
              src="https://store.lenken.com.ar/img/imgSitio/logos/usadosSele.jpg"
            ></Image>
          </Col>
        ) : (
          ""
        )} */}
        <Col
          className="text-center mb-1 d-flex justify-content-center align-items-center"
          lg={9}
          style={{
            backgroundColor: "#D9D9D9",
            fontSize: "2rem",
            color: "black",
            flexWrap: "wrap",
          }}
        >
          {buttonsToRender()}
        </Col>
        <Col
          className="text-left pl-4 mb-1"
          lg={9}
          style={{
            backgroundColor: "#000",
            fontSize: "2rem",
            color: "black",
          }}
        >
          <Row className="m-0 p-0" style={{ height: "40px" }}>
            <Col
              xs={{ span: 10, offset: 1 }}
              md={{ span: 6, offset: 3 }}
              lg={{ span: 4, offset: 4 }}
              className="text-center mt-1"
              style={{ color: "white" }}
            >
              <Form.Group>
                <Form.Control
                  size="sm"
                  type="text"
                  style={{ borderRadius: "0px" }}
                  placeholder="buscar"
                  value={search}
                  onChange={(e) => handleChangeFilter(e)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleSearch();
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Button
              size="sm"
              className="mt-1"
              onClick={() => handleSearch()}
              variant="outline-light"
              style={{
                border: "1px solid white",
                fontWeight: "bold",
                fontFamily: "Audi Extended",
                borderRadius: "0px",
                color: "white",
                height: "30px",
              }}
            >
              buscar
            </Button>
          </Row>
        </Col>
        <Col
          className="text-left p-1 pl-4"
          lg={9}
          style={{
            backgroundColor: "darkgray",
            fontSize: "1.5rem",
            borderRadius: "5px",
            color: "black",
          }}
        >
          {seleccion && seleccion === "combos"
            ? capitalize(seleccion)
            : seleccion}
        </Col>
      </Row>
      <Row className="m-0 p-0 mb-5 justify-content-center text-left">
        {!spinner ? (
          genericCardstoRender()
        ) : (
          <>
            <Row className="mx-0" style={{ marginTop: "2%" }}>
              <Col xs={12} className="text-center">
                Cargando...
              </Col>
              <Col
                xs={12}
                className="text-center mx-0"
                style={{ marginTop: "10px" }}
              >
                <Spinner animation="grow" variant="secondary" />
              </Col>
            </Row>
          </>
        )}
      </Row>
      {getPagination()}
    </>
  );
}
